
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import './Forgotpassword.css'
const ForgotPassword=()=>{
    const[email,setEmail]=useState("");
    const navigate = useNavigate();


    const handleUsernameChange=(event)=>{
        setEmail(event.target.value)
    };
    const handleSubmit=()=>{
        //add api call here
    };

    return (

        <div className="forgotpassword-container">
          {/* <h3 align="center">Samurdhi E- Bank Login</h3> */}
          <form onSubmit={handleSubmit}>
            <div>
              {/* <label align="center" htmlFor="email">email</label> */}
              <input align="center"
                placeholder="Enter your email"
                type="text"
                id="email"
                value={email}
                onChange={handleUsernameChange}
              />
            </div>
            <div>
              {/* <label htmlFor="password">Password</label> */}
             
            </div>
            <div align="center">
              <button type="submit">Reset My Password</button>
            </div>
          </form>
        </div>
      );

};
export default ForgotPassword;